import * as angular from 'angular';
import $ from 'jquery';
import L from 'leaflet';
import WKTParser from 'terraformer-wkt-parser';
import Map from '../../map/map';
import emptyObjectlistModalHtml from './emptyObjectlistModal.html';
import excelImportHtml from './excel-import-modal.html';
import security from '../../../service/security/security-services';
import server from '../../../integration/server/server-services';
import contractService from '../../../service/contract/contract-services';
import datacatalog, {FkbFeatureType, NvdbFeatureType} from '../../../integration/datacatalog/datacatalog-services';
import nvdbapi from '../../../integration/nvdbapi/nvdbapi';
import {contractTypeMap} from '../../../model/enum-contractTypes';
import PermissionResolver from '../../../service/security/PermissionResolver';
import {UserSession} from '../contract-features-3/domain';
import {ContractGroup} from '../admin/groups/GroupAdminState';
import {
    ContractGroup as ServerContractGroup,
    ContractGroupWithData
} from '../../../integration/representation/contract-group';
import {
    ContractMilestone,
    ContractObjectListItem,
    Contributor,
    Destination
} from '../../../integration/representation/contract';
import {ExcelParseRowResult} from '../../../integration/representation/object-list';
import addUserModalHtml from './add-user-modal.html';
import KeyPressEvent = JQuery.KeyPressEvent;

// XXX Code uses Datakatalog classes with extra fields for display, it would be better to have separate classes with only needed fields for this
interface DisplayFeatureType extends NvdbFeatureType {
    fkbFeatureTypes: DisplayFkbFeatureType[];
    selected: boolean;
}

interface DisplayFkbFeatureType extends FkbFeatureType {
    selected: boolean;
}

interface DisplayObjectListItem {
    typeId: number;
    expectedCount: number;
}

interface ContractSettingsControllerState {
    contract: contractService;
    canDeleteContract: boolean;
    canUpdateContract: boolean;
    canArchiveContract: boolean;
    canChangeAssignee: boolean;
    canCreateMilestone: boolean;
    canUpdateMilestone: boolean;
    canDeleteMilestone: boolean;
    canCreateContributor: boolean;
    canDeleteContributor: boolean;
    canUpdateObjectList: boolean;
    hasSensitiveCategoriesForObjects: boolean;
    counties: { [key: string]: string };
    roadCategories: { [key: string]: string };
    roadStatuses: { [key: string]: string };
    newMilestone: ContractMilestone;
    contractStatuses: string[];
    nvdbapi: nvdbapi;
    contractGroup: ServerContractGroup;
    selectedContractGroupId: string;
    contractGroups: ContractGroupWithData[];
    canUpdateContractGroup: boolean;
    hasGlobalCreatePermit: boolean;
    displayContractGroupName: string;
    contractTypes: { [key: string]: string };
    newuser: string;
    originalContractName: string;
    localObjectList: DisplayObjectListItem[];
    localFkbObjectList: DisplayObjectListItem[];
    currentUser: UserSession;
    map: Map;
    iconStyle: L.DivIcon;
    contractBoundary: L.FeatureGroup;
    drawNewControl: L.Control.Draw;
    editDrawControl: L.Control.Draw;
    featureTypes: DisplayFeatureType[];
    timeout: number;

    save: Function;
    cancel: Function;
    isReadyToCreateMilestone: Function;
    createMilestone: Function;
    deleteMilestone: Function;
    toggleArchiveContract: Function;
    deleteContract: Function;
    showEmptyObjectlistModal: Function;
    openExcelImportModal: Function;
    removeContributor: Function;
    getArchivedState: Function;
    toggleFeatureType: Function;
    updateContractGroup: Function;
    openAddUserModal: Function;
}

export default function ContractSettingsController($rootScope: angular.IRootScopeService,
                                                   $scope: any,
                                                   $location: angular.ILocationService,
                                                   $filter: angular.IFilterService,
                                                   $q: angular.IQService,
                                                   $timeout: angular.ITimeoutService,
                                                   security: security,
                                                   $routeParams: angular.route.IRouteParamsService,
                                                   $uibModal: angular.ui.bootstrap.IModalService,
                                                   server: server,
                                                   contract: contractService,
                                                   datacatalog: datacatalog,
                                                   nvdbapi: nvdbapi) {
    const vm: ContractSettingsControllerState = this;

    vm.contract = contract;
    vm.save = save;
    vm.cancel = cancel;
    vm.canDeleteContract = false;
    vm.canUpdateContract = false;
    vm.canArchiveContract = false;
    vm.canChangeAssignee = false;
    vm.canCreateMilestone = false;
    vm.canUpdateMilestone = false;
    vm.canDeleteMilestone = false;
    vm.canCreateContributor = false;
    vm.canDeleteContributor = false;
    vm.canUpdateObjectList = false;
    vm.hasSensitiveCategoriesForObjects = false;
    vm.counties = {};
    vm.roadCategories = {};
    vm.roadStatuses = {};
    vm.newMilestone = {} as ContractMilestone;
    vm.contractStatuses = ['Planlagt', 'Utlyst', 'Igangsatt', 'Ferdig'];
    vm.nvdbapi = nvdbapi;
    vm.contractGroup = null;
    vm.selectedContractGroupId = 'none';
    vm.contractGroups = [];
    vm.canUpdateContractGroup = false;
    vm.hasGlobalCreatePermit = false;
    vm.displayContractGroupName = 'Ingen kontraktgruppe';

    vm.isReadyToCreateMilestone = isReadyToCreateMilestone;
    vm.createMilestone = createMilestone;
    vm.deleteMilestone = deleteMilestone;
    vm.toggleArchiveContract = toggleArchiveContract;
    vm.deleteContract = deleteContract;
    vm.showEmptyObjectlistModal = showEmptyObjectlistModal;
    vm.openExcelImportModal = openExcelImportModal;
    vm.removeContributor = removeContributor;
    vm.getArchivedState = getArchivedState;
    vm.toggleFeatureType = toggleFeatureType;
    vm.updateContractGroup = updateContractGroup;
    vm.openAddUserModal = openAddUserModal;
    vm.contractTypes = contractTypeMap;

    addDatePicker();

    function updateContractGroup() {

        if (vm.selectedContractGroupId) {

            if (vm.selectedContractGroupId === 'none') {
                if (vm.contractGroup != null) {
                    server.removeContractFromGroup($routeParams.contractId, vm.contractGroup.groupid);
                }
            } else {
                server.addContractToGroup($routeParams.contractId, vm.selectedContractGroupId);
            }
        }
    }

    function removeContributor(user: UserSession) {
        server.removeUserFromContract(vm.contract.contractId, user.username).then(function () {
            vm.contract.contributors = vm.contract.contributors.filter(function (contributor) {
                return contributor.username !== user.username;
            });
        });
    }

    function showEmptyObjectlistModal() {
        function controller($scope: any, $uibModalInstance: angular.ui.bootstrap.IModalInstanceService) {
            $scope.ok = function () {
                $uibModalInstance.close({type: 'clear'});
            };
            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        controller.$inject = ['$scope', '$uibModalInstance'];
        const modalInstance = $uibModal.open({
            animation: true,
            template: emptyObjectlistModalHtml,
            controller
        });

        modalInstance.result.then(function () {
            (vm.contract as any).dirty = true;
            vm.contract.objectList = [];
            vm.contract.fkbObjectList = [];
            setObjectListView(vm.contract);
            vm.save();
        }, function () {
            // cancel, do nothing
        });

    }

    interface AddUserModalController {
        searchText: string;
        searchResult?: Contributor[];
        selectedUserIds: string[];
        isSearching: boolean;
        isSaving: boolean;
        newUserMail: string;

        doSearch: Function;
        searchKeyHandler: Function;
        addUsers: Function;
        cancel: Function;
        toggleSelection: Function;
        canSearch: Function;
        canSave: Function;
    }

    function openAddUserModal() {
        function controller(modalInstance: angular.ui.bootstrap.IModalInstanceService, contract: contractService) {
            const vm: AddUserModalController = this;
            vm.selectedUserIds = [];

            vm.doSearch = () => {
                vm.isSearching = true;
                server.findUsers(contract.contractId, vm.searchText)
                    .then(result => {
                        // Remove existing contributors and sort by name
                        const filtered = result.filter(user => !contract.contributors.some(c => c.username === user.username));
                        const collator = Intl.Collator('nb', {numeric: true});

                        const kantegaSort = filtered.sort((a, b) => {
                            // Name is not set for some DB users, fall back to user name
                            const astr = !a.name ? a.username : a.name;
                            const bstr = !b.name ? b.username : b.name;
                            return collator.compare(astr, bstr);
                        });

                        // Set exact matches on top
                        const exactMatches = kantegaSort.filter(user =>
                            user.name.toLowerCase().includes(vm.searchText.toLowerCase()) ||
                            user.username.toLowerCase().includes(vm.searchText.toLowerCase())
                        );

                        const otherMatches = kantegaSort.filter(function(el) {
                            return !exactMatches.includes(el);
                          });

                        const matches =  [...exactMatches, ...otherMatches];

                        // Highlight
                        const regex = new RegExp(vm.searchText, 'gi');

                        const matchesHighlight = matches.map(user => {
                            const newName = user.name.replace(regex, '<mark>$&</mark>');
                            const newUsername = user.username.replace(regex, '<mark>$&</mark>');
                            return {name: newName, username: newUsername};
                        });

                        vm.searchResult = matchesHighlight;
                        vm.isSearching = false;
                    })
                    .catch(() => vm.isSearching = false);
            };

            vm.searchKeyHandler = (event: KeyPressEvent) => {
                // Enable search by pressing "enter". The event is an jQuery event, as described in AngularJS event docs.
                if (event.key === 'Enter') {
                    vm.doSearch();
                }
            };

            vm.addUsers = () => {
                vm.isSaving = true;


                const addPromises = vm.selectedUserIds.map(userIdWithHighlightTags => {
                    // Removes html highlight tags
                    const regex = /(<([^>]+)>)/ig;
                    const userId = userIdWithHighlightTags.replace(regex, '');
                    return server.addUserToContract(contract.contractId, userId);
                });

                let emailUser: Contributor;
                if (vm.newUserMail) {
                    // Check if mail user is already added. Should ideally be a validator check instead, but that's harder to achieve.
                    if (!contract.contributors.some(c => c.username === vm.newUserMail)) {
                        addPromises.push(server.addUserToContract(contract.contractId, vm.newUserMail));
                        emailUser = {username: vm.newUserMail, name: ''};
                    }
                }

                Promise.all(addPromises)
                    .then(() => {
                        vm.isSaving = false;
                        const selectionAsContributor: Contributor[] = vm.selectedUserIds.map(userId => {
                            const user = vm.searchResult.find(user => user.username === userId);

                            // Removes html highlight tags
                            const regex = /(<([^>]+)>)/ig;
                            const usernameTrimmed = user.username.replace(regex, '');
                            const nameTrimmed = user.name.replace(regex, '');

                            return {username: usernameTrimmed, name: nameTrimmed};
                        });
                        if (emailUser) {
                            selectionAsContributor.push(emailUser);
                        }
                        modalInstance.close(selectionAsContributor);
                    })
                    .catch(() => vm.isSaving = false);

            };

            vm.cancel = () => {
                modalInstance.dismiss();
            };

            vm.toggleSelection = (userId: string) => {
                const index = vm.selectedUserIds.indexOf(userId);
                if (index !== -1) {
                    vm.selectedUserIds.splice(index, 1);
                } else {
                    vm.selectedUserIds.push(userId);
                }
            };

            vm.canSearch = () => {
                return vm.searchText && !vm.isSearching && !vm.isSaving;
            };

            vm.canSave = () => {
                return (vm.selectedUserIds.length > 0 || vm.newUserMail) && !vm.isSearching && !vm.isSaving;
            };
        }

        controller.$inject = ['$uibModalInstance', 'contract'];
        const instance = $uibModal.open({
            animation: true,
            template: addUserModalHtml,
            controller,
            controllerAs: 'ctrl'
        });
        instance.result.then(result => {
            vm.contract.contributors.push(...result);
        }).catch(() => {/* Dialog cancelled by user, catch here to avoid Angular alert about unhandled rejection. */
        });
    }


    function openExcelImportModal() {
        function mapTonameAndFilter(list: ExcelParseRowResult[], filtervalue: string): string[] {
            return list.filter(function (featuretype) {
                return featuretype.result == filtervalue;
            }).map(function (featuretype) {
                return featuretype.featuretypeName;
            });
        }

        function controller($scope: any, $uibModalInstance: angular.ui.bootstrap.IModalInstanceService,
                            security: security, contract: contractService) {
            function uploadNewFile(file: File) {
                $scope.uploadingFiles = true;

                server.uploadExcelFile(contract.contractId, file).then(function (response) {
                    $scope.uploadingFiles = false;
                    const parseResult = response.data;

                    if (parseResult.result === 'OK') {
                        $uibModalInstance.close({type: 'ok'});
                        vm.contract.readObjectLists().then(function () {
                            setObjectListView(vm.contract);
                        });
                    } else {
                        $scope.error = 'Ukjente FKB-typer';
                        const knownNames = mapTonameAndFilter(parseResult.fkbResults, 'OK');
                        const unknownNames = mapTonameAndFilter(parseResult.fkbResults, 'UNKNOWN_FEATURE_NAME');
                        const fkbFeatureTypeNames = datacatalog.getFkbFeatureTypeNames();
                        const filteredFkbFeatureTypeNames = fkbFeatureTypeNames.filter(function (name) {
                            return knownNames.indexOf(name) == -1;
                        });
                        $scope.unknownNames = unknownNames;
                        $scope.nameAlternatives = filteredFkbFeatureTypeNames;
                        security.ensureCurrentUser().then(user => {
                            $scope.canUpdateFkbAlias = user.hasPermission('FKB_ALIAS:UPDATE');
                        });
                        $scope.resolvedNames = {};
                        $scope.allUnknownHandled = function () {
                            return Object.keys($scope.resolvedNames).length === unknownNames.length;
                        };
                        $scope.updateNamesAndUpload = function () {
                            const updatedNames = Object.keys($scope.resolvedNames).map(function (unknownName) {
                                return {unknownName, knownName: $scope.resolvedNames[unknownName]};
                            });
                            server.saveFkbAliases(updatedNames).then(function () {
                                uploadNewFile(file);
                            });
                        };
                    }
                }, function (rejection) {
                    $scope.uploadingFiles = false;
                    $scope.error = rejection.data.message;
                    return rejection;
                });
            }

            $scope.uploadNewFile = uploadNewFile;
            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        controller.$inject = ['$scope', '$uibModalInstance', 'security', 'contract'];
        $uibModal.open({
            animation: true,
            template: excelImportHtml,
            controller
        });
    }

    function save() {
        if (!$scope.editContractForm.$invalid) {
            if ((vm.contract as any).dirty) {
                vm.contract.updateContract();
                delete (vm.contract as any).dirty;
            }
        }
    }

    function cancel() {
        vm.contract.reloadContract().then(function () {
            $location.url('/contract/' + vm.contract.contractId + '/settings');
        });
    }

    function setObjectListView(contract: contractService) {
        const fkbObjectListById: { [key: number]: ContractObjectListItem } = {};
        angular.forEach(contract.fkbObjectList, function (featureType) {
            fkbObjectListById[featureType.typeId] = featureType;
        });

        buildFeatureTypes(contract.objectList, fkbObjectListById);
        vm.localObjectList = [];
        vm.localFkbObjectList = [];

        vm.localObjectList = contract.objectList
            .map(type => ({typeId: type.typeId, expectedCount: type.expectedCount}));

        vm.localFkbObjectList = contract.fkbObjectList
            .map(type => ({typeId: type.typeId, expectedCount: type.expectedCount}));

        return contract;
    }

    function init() {
        $q.all([security.ensureCurrentUser(), contract.selectContract($routeParams.contractId)])
            .then(function (data) {
                const user: UserSession = data[0];
                const contract: contractService = data[1];

                setObjectListView(contract);

                vm.originalContractName = contract.name;
                vm.currentUser = user;
                vm.canDeleteContract = user.hasPermission('CONTRACT:DELETE', $routeParams.contractId);
                vm.canUpdateContract = user.hasPermission('CONTRACT:UPDATE', $routeParams.contractId);
                // Must be owner or admin to archive contract, in addition to permission
                vm.canArchiveContract = user.hasPermission('CONTRACT:ARCHIVE', $routeParams.contractId)
                    && (contract.assignee === user.username
                        || user.globalAdmin || user.isGroupAdmin(contract.contractGroup));
                // Must be global admin or group admin to change assignee
                vm.canChangeAssignee = user.hasPermission('CONTRACT:UPDATE', $routeParams.contractId)
                    && (user.globalAdmin || user.isGroupAdmin(contract.contractGroup));
                vm.canCreateMilestone = user.hasPermission('MILESTONE:CREATE', $routeParams.contractId);
                vm.canUpdateMilestone = user.hasPermission('MILESTONE:UPDATE', $routeParams.contractId);
                vm.canDeleteMilestone = user.hasPermission('MILESTONE:DELETE', $routeParams.contractId);
                vm.canCreateContributor = user.hasPermission('CONTRIBUTOR:CREATE', $routeParams.contractId);
                vm.canDeleteContributor = user.hasPermission('CONTRIBUTOR:DELETE', $routeParams.contractId);
                vm.canUpdateObjectList = user.hasPermission('OBJECTLIST:UPDATE', $routeParams.contractId);
                vm.hasGlobalCreatePermit = user.hasPermission('CONTRACT:CREATE', PermissionResolver.GLOBAL_PERMISSION_SCOPE, PermissionResolver.GLOBAL_PERMISSION_SCOPE);
                vm.hasSensitiveCategoriesForObjects = hasAllSensitiveCategories(contract, user);

                purgeStaleFkbObjects(datacatalog, contract);
                initMap();

                nvdbapi.getCounties().then(response => {
                    response.data.forEach(county => {
                        vm.counties[county.nummer] = county.navn;
                    });
                }).catch(err => {
                    console.warn('Failed to load counties from API LES', err);
                });

                server.getContractGroupList().then(response => {
                    const contractGroups: ContractGroupWithData[] = response.data ?? [];

                    server.getContractGroupForContract($routeParams.contractId)
                        .then(groupResponse => {
                            if (groupResponse.success) {
                                vm.contractGroup = groupResponse.data;
                                vm.selectedContractGroupId = groupResponse.data.groupid;
                                vm.displayContractGroupName = groupResponse.data.groupName ? groupResponse.data.groupName : 'Ingen kontraktgruppe';
                                vm.canUpdateContractGroup = user.hasPermission('CONTRACTGROUP:REMOVECONTRACT', null, groupResponse.data.groupid);

                                // The user may have permissions for this contract, but not its group.
                                // add the contract's group to the list of selectable groups for this user, if it is not already there
                                if (!contractGroups.some(group => group.id == groupResponse.data.groupid)) {
                                    contractGroups.push({
                                        id: groupResponse.data.groupid,
                                        name: groupResponse.data.groupName,
                                        contracts: [],
                                        users: []
                                    });
                                }


                            } else {
                                vm.contractGroup = null;
                                vm.canUpdateContractGroup = true;   // must still have permission to update contract
                            }
                        })
                        .finally(() => {
                            type CompareType = (a: ContractGroup, b: ContractGroup) => number;
                            const intlCollator = Intl.Collator('nb', {numeric: true});
                            const compareContractNames = (intlCollator: Intl.Collator): CompareType => {
                                return function compareWithIntlCollator(a: ContractGroup, b: ContractGroup): number {
                                    return intlCollator.compare(a.name, b.name);
                                };
                            };
                            contractGroups.sort(compareContractNames(intlCollator));
                            vm.contractGroups = contractGroups;
                        });
                });
            });

        $scope.updateMilestoneDeadline = updateMilestoneDeadline;
        $scope.updateMilestoneName = updateMilestoneName;
        $scope.updateMilestoneDescription = updateMilestoneDescription;

        vm.roadCategories = datacatalog.getRoadCategories();
        vm.roadStatuses = datacatalog.getRoadStatuses();

        initSlider();
    }

    function initMap() {
        vm.map = new Map(document.getElementById('contract-boundary-map'));
        vm.iconStyle = new L.DivIcon({
            iconSize: new L.Point(5, 5)
        });

        L.drawLocal.draw.toolbar.buttons.polygon = 'Tegn inn kontraktens område';
        L.drawLocal.edit.toolbar.buttons.edit = 'Rediger kontraktens område';
        L.drawLocal.edit.toolbar.buttons.remove = 'Slett kontraktens område';

        vm.contractBoundary = L.featureGroup();
        vm.contractBoundary.addTo(vm.map.leafletMap);

        initControls();
        initDrawEventHandlers();

        vm.contract.getContractBoundary().then((boundaryWkt) => {
            if (!boundaryWkt || boundaryWkt == 'null') {
                vm.map.leafletMap.addControl(vm.drawNewControl);
            } else {
                const feature = WKTParser.parse(boundaryWkt) as any;
                const featureLayer = L.polygon(feature.coordinates[0]);
                vm.contractBoundary.addLayer(featureLayer);
                vm.map.leafletMap.addControl(vm.editDrawControl);
            }
        });
    }

    function initDrawEventHandlers() {
        vm.map.leafletMap.on(L.Draw.Event.CREATED, (e) => {
            const wkt = latLngToWkt((e as any).layer._latlngs[0]);
            vm.contract.setContractBoundary(wkt);

            vm.contractBoundary.addLayer((e as any).layer);
            vm.map.leafletMap.removeControl(vm.drawNewControl);
            vm.map.leafletMap.addControl(vm.editDrawControl);
        });

        vm.map.leafletMap.on(L.Draw.Event.DELETED, (e) => {
            if (!isEmptyObject((e as any).layers._layers)) {
                vm.contract.setContractBoundary('');

                vm.contractBoundary.removeLayer((e as any).layer);
                vm.map.leafletMap.removeControl(vm.editDrawControl);
                vm.map.leafletMap.addControl(vm.drawNewControl);
            }
        });

        vm.map.leafletMap.on(L.Draw.Event.EDITED, (e) => {
            const layers: any[] = [];
            (e as any).layers.eachLayer((layer: any) => {
                layers.push(layer);
            });
            assertOnlyOneElementInArray(layers);
            const wkt = latLngToWkt(layers[0]._latlngs[0]);
            vm.contract.setContractBoundary(wkt);
        });
    }

    function assertOnlyOneElementInArray(arr: any[]) {
        if (arr.length !== 1) {
            throw new Error('Expected size of array to be 1. Actually ' + arr.length);
        }
    }

    function initControls() {
        vm.drawNewControl = new L.Control.Draw({
            draw: {
                polygon: {
                    icon: vm.iconStyle
                } as any,
                rectangle: false,
                polyline: false,
                marker: false,
                circle: false
            } as any
        });

        vm.editDrawControl = new L.Control.Draw({
            edit: {
                featureGroup: vm.contractBoundary
            },
            draw: {
                polygon: false,
                rectangle: false,
                polyline: false,
                marker: false,
                circle: false
            }

        } as any);
    }

    function latLngToWkt(coords: L.LatLng[]) {
        const coordinates = coords.map(point => {
            return [point.lat, point.lng, 0];
        });
        coordinates.push(coordinates[0]);
        return WKTParser.convert({
            type: 'Polygon',
            coordinates: [coordinates]
        });
    }

    function buildFeatureTypes(nvdbObjectList: ContractObjectListItem[], fkbObjectList: { [key: number]: ContractObjectListItem }) {
        vm.featureTypes = [];
        datacatalog.getFeatureTypes()                     // finner NVDB-features
            .filter(t => t.inObjectList)        // finner NVDB-objekter som er i default objektliste
            .forEach(featureType => {
                const selected = nvdbObjectList.some(t => t.typeId == featureType.id);
                const fkbFeatureTypes = datacatalog.getFKBFeatureTypes()
                    .filter(t => t.nvdbId == featureType.id)        // finner objekter i default FKB objektliste
                    .filter(t => t.verified) as DisplayFkbFeatureType[];             // verified betyr at det er en "godkjent global fkb-type"
                if (!!fkbFeatureTypes && fkbFeatureTypes.length > 0) {                                       // Vi har funnet noen
                    fkbFeatureTypes.sort((a, b) => a.sortNum - b.sortNum);
                    const mergedType = angular.copy(featureType) as DisplayFeatureType;
                    mergedType.fkbFeatureTypes = fkbFeatureTypes;                                               // setter fkb-objekttypers som sub-type på nvdb-objekttypen
                    mergedType.selected = selected;
                    fkbFeatureTypes.forEach(type => type.selected = !!fkbObjectList[type.id]);        // sette selected hvis dem finnes i prosjektets objektliste

                    vm.featureTypes.push(mergedType);                                                           // lagrer dem
                } else {                                                                                     // Fant ikke noen
                    const nvdbOnlyType = angular.copy(featureType) as DisplayFeatureType;                                             // lagrer nvdb-featuretype uten fkb sub-type
                    nvdbOnlyType.selected = selected;
                    vm.featureTypes.push(nvdbOnlyType);
                }
            });

        const pureFkbTypes = datacatalog.getFKBFeatureTypes()                                               // finner fkb-featuretyper uten nvdb-motpart
            .filter(type => !type.nvdbId)                             // det vet vi fordi de ikke har noen kjente nvdb-id, og dermed ikke er plukket opp over
            .filter(t => t.verified);                                 // men bare featuretyper som er godkjent som globale fkb-typer
        pureFkbTypes.forEach(type => {
            const fkbType = {} as any;
            fkbType.fkbFeatureTypes = [angular.copy(type)];                                                 // setter fkb-featuretypen som en sub-type til en tom featuretype (wat)
            fkbType.fkbFeatureTypes[0].selected = !!fkbObjectList[type.id];                                 // setter at den er selected hvis den finnes i objektlista til prosjektet
            vm.featureTypes.push(fkbType);                                                                  // lagrer den
        });

        vm.featureTypes.sort((a, b) => {
            const firstSortNum = a.sortNum ? a.sortNum : (a.fkbFeatureTypes ? a.fkbFeatureTypes[0].sortNum : 0);
            const secondSortNum = b.sortNum ? b.sortNum : (b.fkbFeatureTypes ? b.fkbFeatureTypes[0].sortNum : 0);
            const diff = firstSortNum - secondSortNum;
            if (diff == 0) {
                return 0;
            }
            return (diff > 0) ? 1 : -1;
        });
    }

    function toggleFeatureType(featureType: DisplayFeatureType, destination: Destination) {
        const selected = !featureType.selected;
        featureType.selected = selected;

        if (selected) {
            addFeatureType(featureType, destination);
        } else {
            removeFeatureType(featureType, destination);
        }

        if (vm.timeout) {
            window.clearTimeout(vm.timeout);
        }

        vm.timeout = window.setTimeout(() => {
            contract.updateObjectLists(vm.localObjectList, vm.localFkbObjectList);
        }, 1000);

    }

    function addFeatureType(featureType: DisplayFeatureType, destination: Destination) {
        if (destination == 'NVDB') {
            vm.localObjectList.push({typeId: featureType.id, expectedCount: 0});
        } else {
            vm.localFkbObjectList.push({typeId: featureType.id, expectedCount: 0});
        }
    }

    function removeFeatureType(featureType: DisplayFeatureType, destination: Destination) {
        if (destination == 'NVDB') {
            vm.localObjectList = vm.localObjectList.filter(type => {
                return type.typeId != featureType.id;
            });
        } else {
            vm.localFkbObjectList = vm.localFkbObjectList.filter(fkbType => {
                return fkbType.typeId != featureType.id;
            });
        }
    }


    function isReadyToCreateMilestone() {
        return vm.newMilestone.deadline !== undefined &&
            vm.newMilestone.name !== undefined &&
            vm.newMilestone.description !== undefined &&
            (vm.newMilestone as any).deadline instanceof Date;
    }

    function createMilestone() {
        if (isReadyToCreateMilestone()) {
            const milestone: ContractMilestone = {
                deadline: toDateString(vm.newMilestone.deadline),
                name: vm.newMilestone.name,
                description: vm.newMilestone.description,
                id: null,
                approved: false
            };

            vm.contract.saveMilestone(milestone).then(function () {
                vm.newMilestone = {} as ContractMilestone;
            });
        }
    }

    function updateMilestoneDeadline(milestone: ContractMilestone, deadline: any) {
        if (deadline instanceof Date) {
            (milestone as any).deadline = deadline;
            updateMilestone(milestone);
        } else {
            return 'Ikke en gyldig dato';
        }
    }

    function updateMilestoneName(milestone: ContractMilestone, name: string) {
        if (name.length <= 200) {
            milestone.name = name;
            updateMilestone(milestone);
        } else if (name.length < 1) {
            return 'Navn må ha minimum 1 bokstav';
        } else {
            return 'Navn kan maksimalt ha 200 bokstaver';
        }
    }

    function updateMilestoneDescription(milestone: ContractMilestone, description: string) {
        if (description.length <= 4096) {
            milestone.description = description;
            updateMilestone(milestone);
        } else if (description.length < 1) {
            return 'Beskrivelse må ha minimum 1 bokstav';
        } else {
            return 'Beskrivelsen kan maksimalt ha 4096 bokstaver';
        }
    }

    function updateMilestone(milestone: ContractMilestone) {
        // New object so that we controll how deadline is serialized.
        vm.contract.saveMilestone({
            id: milestone.id,
            deadline: toDateString(milestone.deadline),
            name: milestone.name,
            description: milestone.description,
            approved: false
        });
    }

    function deleteMilestone(milestoneId: string) {
        if (vm.contract.archivedState == 'OPEN') {
            vm.contract.deleteMilestone(milestoneId);
        }
    }

    function toDateString(date: string) {
        return $filter('date')(date, 'yyyy-MM-dd');
    }

    function deleteContract() {
        contract.deleteContract().then(() => {
            $location.path('/contract');
        });
    }

    function toggleArchiveContract() {
        const archiveState = vm.contract.archivedState == 'OPEN' ? 'ARCHIVED' : 'OPEN';
        contract.toggleArchiveContract(vm.contract.contractId, archiveState)
            .then(() => contract.selectContract($routeParams.contractId))
            .then((data) => vm.contract = data);
    }

    function getArchivedState() {
        return vm.contract.archivedState == 'OPEN' ? 'Arkiver' : 'Reaktiver';
    }

    function addDatePicker() {
        $scope.dateOptions = {
            startingDay: 1
        };

        $scope.newMilestonestatus = {
            opened: false
        };
        $scope.newMilestoneOpenDatepicker = function () { // for datepicker
            $scope.newMilestonestatus.opened = true;
        };

        $scope.newMilestoneCloseDatepicker = function () {
            $scope.newMilestonestatus.opened = false;
        };

        $scope.editMilestonePicker = {
            opened: false
        };

        $scope.editMilestoneOpenPicker = function () {
            $timeout(function () {
                $scope.editMilestonePicker.opened = true;
            });
        };

        $scope.editMilestoneClosePicker = function () {
            $scope.editMilestonePicker.opened = false;
        };
    }

    init();
}

function initSlider() {
    const $objectlistEditor = $('#objectlistEditor');
    $objectlistEditor.on('click', '.ol_closebutton', function () {
        $(this).parents('.ol_element').slideUp();
    });

    $objectlistEditor.on('click', '.ol_header', function () {
        const $this = $(this);
        const expanderButton = $this.find('.expander-button').eq(0);
        if (expanderButton.hasClass('glyphicon-chevron-down')) {
            expanderButton.removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-up');
            $this.next('.expander-container').slideDown();
            return;
        }
        if (expanderButton.hasClass('glyphicon-chevron-up')) {
            expanderButton.removeClass('glyphicon-chevron-up').addClass('glyphicon-chevron-down');
            $this.next('.expander-container').slideUp();
        }
    });
}

function purgeStaleFkbObjects(datacatalog: datacatalog, contract: contractService) {
    const fkbListLength = contract.fkbObjectList.length;
    contract.fkbObjectList = datacatalog.purgeStaleFkbObjects(contract.objectList, contract.fkbObjectList);
    if (fkbListLength != contract.fkbObjectList.length) {
        contract.persistObjectLists();
    }
}

function isEmptyObject(obj: object) {
    return Object.getOwnPropertyNames(obj).length === 0;
}

/**
 * Check if user has all sensitive categories for contract.
 *
 * @param contract Contract to check
 * @param user User session
 */
function hasAllSensitiveCategories(contract: contractService, user: UserSession): boolean {
    return contract.sensitiveCategories.every(contractCategory =>
        user.sensitiveTypes.some(userCategory => userCategory === contractCategory));
}


ContractSettingsController.$inject = ['$rootScope', '$scope', '$location', '$filter', '$q', '$timeout', 'security', '$routeParams', '$uibModal', 'server', 'contract', 'datacatalog', 'nvdbapi'];
